export enum PcrBackupConstants {
  PCR_SAVED = 'pcrBackup/PCR_SAVED',
  SET_METADATA = 'pcrBackup/SET_METADATA',
  RESET = 'pcrBackup/RESET',
  PERSIST_PRID = 'pcrBackup/PERSIST_PRID',
}
